/**
 * useRecommendations
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import RecommendationsContext from './recommendations-context'

const useRecommendations = () => {
  const context = useContext(RecommendationsContext)
  return context
}

export default useRecommendations
